import { use_effect } from '@/hooks/_base/use_effect';
import { UTILS__image } from '@/utils/UTILS__image';
import { path_relative_to_absolute } from '@/utils/utils_files_client';
import { assert_not_null } from '@shared/asserts/utils_asserts';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { useState } from 'react';

export function HOOK_CANVAS__from_image(image: DTO__image_asset) {
  /*
   * STATE
   */

  const [canvas, set_canvas] = useState(new OffscreenCanvas(0, 0));

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (image.is_stub()) return;

    void load_image_and_draw();
  }, [image.url_relative, image.updated_at]);

  /*
   * METHODS
   */
  async function load_image_and_draw(): Promise<void> {
    let url_absolute = path_relative_to_absolute(image.url_relative_latest);

    const image_tag: HTMLImageElement = await UTILS__image.load_from_url(url_absolute);

    let { width, height } = image.image_size;

    let canvas_new = new OffscreenCanvas(width, height);
    const context = canvas_new.getContext('2d', { willReadFrequently: true });
    assert_not_null(context);

    set_canvas(canvas_new);

    context.imageSmoothingEnabled = false;
    context.drawImage(image_tag, 0, 0, width, height);
  }

  return canvas;
}
